import { DG } from '../dg';
import type { DocumentState, TextNode } from '../dg/document/document-types';

export const DEFAULT_DOCUMENT_STATE: DG.DocumentEditor.DocumentState = {
  type: 'doc',
  content: [],
};

export function parseDocumentState(
  raw: unknown
): DG.DocumentEditor.DocumentState {
  const parsed = raw as DG.DocumentEditor.DocumentState;
  if (
    parsed !== null &&
    typeof parsed === 'object' &&
    'type' in parsed &&
    parsed.type === 'doc'
  ) {
    const rawContent = (parsed as { content?: unknown }).content;
    const content = Array.isArray(rawContent) ? rawContent : [];
    return { type: 'doc', content };
  }
  return { type: 'doc', content: [] };
}

/** First H1 heading text from TipTap document JSON, or null (same rule as graph `EditorState.title()`). */
export function titleFromDocumentState(state: DocumentState): string | null {
  return state.type === 'doc' &&
    (state.content?.length ?? 0) > 0 &&
    state.content?.[0]?.type === 'heading' &&
    state.content?.[0].attrs?.['level'] === 1
    ? (state.content[0].content?.[0] as TextNode)?.text ?? null
    : null;
}
